import { trpc, type RouterOutputs } from '@org/clients/school';

export type AccessMe = RouterOutputs['access']['me'];

/**
 * The student's access snapshot (`access.me`): who they are, whether their
 * identity is validated, and the base-access state (trial / paid / expired).
 * One query shared by the gate, the banner, the sidebar and the store —
 * react-query dedupes the callers.
 */
export function useAccess() {
  return trpc.access.me.useQuery(undefined, {
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
